<template>
  <div class="navbar">
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    <div class="right-menu flex">
      <div class="flex ai-c user_info"><img :src="require('@/assets/images/face.png')">{{userInfo.deptNames ?? ''}} - {{userInfo.userName ?? ''}}</div>    
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <i class="iconfont icon-touxiang"></i>{{UserName}}
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">            
          <el-dropdown-item>
            <span style="display:block;" @click="changePass">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item>
            <span style="display:block;" @click="logout">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <el-button type="warning" size="mini" icon="el-icon-close" @click="logout" circle></el-button> -->
    </div>
    <el-dialog title="修改密码" :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false"
    width="400px">
      <el-form :model="passForm" status-icon :rules="passFormRules" ref="passForm" label-width="100px">
        <el-form-item label="旧密码" prop="newpwd">
              <el-input type="password" v-model="passForm.oldPassword" auto-complete="off" size="mini"></el-input>
          </el-form-item>  
        <el-form-item label="新密码" prop="newpwd">
              <el-input type="password" v-model="passForm.newPassword" auto-complete="off" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="renewpwd">
              <el-input type="password" v-model="passForm.confirmPassword" auto-complete="off" size="mini"></el-input>
          </el-form-item>
      </el-form>
      <div class="text-R">
        <el-tooltip class="item" effect="dark" content="确认" placement="bottom">
          <el-button type="primary" size="mini" icon="iconfont icontijiao" @click="change()"></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="重置" placement="bottom">
          <el-button size="mini" icon="iconfont iconzhongzhi" @click="resetForm('passForm')"></el-button>
        </el-tooltip>
      </div>
  </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Hamburger from '@/components/Hamburger'
import ApiUrls from '@/api/apiUrls'
var noticeTimeOut = null;
var noticeInterval = null;
import CustomerClient from "@/api/customer"
import { login, getUserMenu, getUserPermission, UserInfoForUser } from '@/api/login.js'

export default {
  data() {
    var validatePass = (rule, value, callback) => {
					if (!value) {
						callback(new Error('请输入新密码'));
					} else if (value.toString().length < 6 || value.toString().length > 18) {
						callback(new Error('密码长度为6 - 18个字符'))
					} else {
						callback();
					}
				};
    var validatePass2 = (rule, value, callback) => {
            if (value === '') {
            callback(new Error('请再次输入密码'));
            } else if (value !== this.passForm.newpwd) {
            callback(new Error('两次输入密码不一致!'));
            } else {
            callback();
            }
        };
    return {
      language:"zhCN",
      UserName:window.localStorage.getItem("UserName"),
      dialogVisible:false,
      passForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      passFormRules: {
        newPassword: [
              { required: true, validator: validatePass, trigger: 'blur' }
          ],
          confirmPassword: [
              { required: true, validator: validatePass2, trigger: 'blur' }
          ]
      },
      notice:[
        "您有新的消息...",
        "有新的消息...",
        "新的消息...",
        "的消息...",
        "消息...",
        "息...",
        "...",
      ],
      noticeIndex:0,
      userInfo: {}
    }
  },
  components: {
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  mounted() {
    //获取语言
    let lan = window.localStorage.getItem("lan") || "zhCN"
    this.language = lan
    this.$store.state.lanType = lan;
    //this.getNotice();//获取通知
    this.getUserInfo();
  },
  methods: {
    //切换语言，改变页面值
    switchLang(val) {
      // this.$i18n.locale = val;
      window.localStorage.setItem("lan", val);
      if (this.language=="zhCN") {
          this.$store.state.lanType="zhCN"
      } else {
          this.$store.state.lanType="en"
      }
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      //await this.$store.dispatch('user/logout')
      window.localStorage.removeItem("menus");
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("UserName");
      window.localStorage.removeItem("UserId");
      this.$router.push('/login')
    },
    changePass(){
      this.dialogVisible = true;
    },
    change(){
      this.$refs.passForm.validate(valid => {
          if(valid){
            CustomerClient.PasswordEdit(this.passForm)
            .then((res)=>{
              if(res.errorcode == 0){
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
                this.resetForm("passForm");
                this.dialogVisible = false;
                this.$router.push('/login')
              }else{
                this.$message.error('修改失败!');
                this.resetForm("passForm");
                this.dialogVisible = false;
              }
            })

            // let para = {};
            // this.$reqPost(ApiUrls.ChangePassWord+"?PassWord="+this.passForm.newpwd,para)
            // .then((res)=>{
            //     if(res.isSuccess == true){
            //         this.$message({
            //             message: "修改成功",
            //             type: "success"
            //         });
            //         this.resetForm("passForm");
            //         this.dialogVisible = false;
            //     }else{
            //         this.$message.error('修改失败!');
            //         this.resetForm("passForm");
            //         this.dialogVisible = false;
            //     }
            // })
          }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getNotice(){
      let that = this;
      clearTimeout(noticeTimeOut);
      this.$reqPost(ApiUrls.GetNoticeList,{})
      .then((res)=>{
        if(res.isSuccess == true){
          if(res.result.length>0){
            this.titleNotice();
            //如果有数据则
            this.browserNotice();
            res.result.forEach(element => {
              //循环多个
              that.$notify({
                title: element.Title,
                message: element.NoticeContent,
                duration: 10000,
                onClick(){
                  that.clickBack(element.Id,1);
                },
                onClose(){
                  that.clickBack(element.Id,2);
                }
              });
            });
          }
          else{
            //如果没有
            clearInterval(noticeInterval);
            document.title = "OA"
            noticeTimeOut = setTimeout(function(){
              that.getNotice();
            },60000)
          }
        }
        else{
          //如果没有
          clearInterval(noticeInterval);
          document.title = "OA"
          noticeTimeOut = setTimeout(function(){
            that.getNotice();
          },300000)
        }
      })
    },
    clickBack(Id,type){
      clearInterval(noticeInterval);
      document.title = '锡澄环保';
      if(type == 1){
        //回调接口
        this.$router.push("/MyTask/Todo")
        this.$reqPost(ApiUrls.ReadNotice+"?DataId="+Id,{})
        .then((res)=>{
        })
      }
    },
    titleNotice(){
      let that = this;
      noticeInterval = setInterval(()=>{
        document.title = that.notice[that.noticeIndex];
        that.noticeIndex++;
        if(that.noticeIndex==that.notice.length){
          that.noticeIndex = 0;
        }
      },500)
      
    },
    browserNotice(){
      if (!("Notification" in window)) {
        console.log("浏览器不支持消息通知");
        return;
      }
      if(Notification.permission == "granted") {
        var notification = new Notification('锡澄环保',{
        body:"你有一条新消息",
        icon:'https://jsxchky.com/'+'favicon.ico'
      });
      }else{
        Notification.requestPermission(function (permission) {});
      }
    },
    getUserInfo(){
      let userInfo = window.localStorage.getItem("userInfo");
      if(userInfo){
        this.userInfo = JSON.parse(userInfo);
      }else{
      
        UserInfoForUser({}).then(res=>{
          console.log('user', res)
          if(res.errorcode === 0){
            this.userInfo = res.data;
            // window.localStorage.setItem("userInfo", JSON.stringify(res.data));
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$bg:#0063be;
.selectWidth{width:80px!important;}
.company-name{margin:0 10px;}
.navbar {
  height: 60px;
  overflow: hidden;
  position: relative;
  background: $bg;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    color:#fff;
    padding-right:15px;
    font-size: 12px;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        color:#fff;
        font-size: 16px;
        i{
          margin:0 5px 0 0;
        }
      }
    }
  }
}
.todo-list{position:relative;margin:0 20px 0 0}
.todo-list em{position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 5px;
    background: #f00;
    right: -5px;
    border: 1px solid #fff;
    top: -10px;}

/**用户信息 */
.user_info{
  font-size: 14px;
  font-weight: bold;
  margin-right: 15px;
  img{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin: 0 10px 0 0;
  }
}
</style>
